"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findIndexWith = exports.findIndex = void 0;

var _pipe = require("../pipe/pipe");

var _curry = require("../curry/curry");

var _isMatch = require("../is-match/is-match");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _findIndex = function _findIndex(_fn, _source) {
  var fn = Array.isArray(_fn) ? _pipe.pipe.apply(void 0, _toConsumableArray(_fn)) : _fn;
  var source = Array.isArray(_source) ? _source : [_source];

  for (var i = 0, length = source.length; i < length; i++) {
    var found = fn(source[i], i, source);

    if (found === true) {
      return i;
    }
  }

  return -1;
};
/**
 * Find the position the first element that satisfies a predicate function
 *
 * @param {Fn|Fn[]}  fn     Predicate applied to each element
 * @param {Object[]} source Source array to iterate over
 *
 * @return {Number} Position of found element or -1 if not found
 *
 * @name findIndex
 * @tag Array
 * @signature (fn: Function, source: Object[]): Number
 *
 * @example
 * const comments = [{id: 1, body: ""}, {id: 2, body: "dolor"}]
 *
 * findIndex(item => item.body === "lorem")(comments)
 * // => -1
 *
 * findIndex([get("body"), equals("dolor")], null, comments)
 * // => 1
 */


var findIndex = (0, _curry.curry)(_findIndex);
exports.findIndex = findIndex;
var findIndexWith = (0, _curry.curry)(function (subset, source) {
  return _findIndex((0, _isMatch.isMatch)(subset), source);
});
exports.findIndexWith = findIndexWith;